import { render, staticRenderFns } from "./MembersBase.vue?vue&type=template&id=a479e972&scoped=true&"
import script from "./MembersBase.vue?vue&type=script&lang=js&"
export * from "./MembersBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a479e972",
  null
  
)

export default component.exports